import { Theme } from '@mui/material/styles';
import { SxProps } from '@mui/system';
import { MiViewColors, MiViewFontSize } from 'miview-ui/miviewTheme';

export const cardWrapperStyle: SxProps<Theme> = {
  padding: '10px 0 0 10px',
  borderBottom: `1px solid ${MiViewColors.softGray}`,
};

export const cepInfoWrapperStyle: SxProps<Theme> = {
  gap: '4px',
  paddingRight: '4px',
};

export const cepDateBlockStyle: SxProps<Theme> = {
  fontSize: MiViewFontSize.small,
};

export const percentBlockStyle: SxProps<Theme> = {
  fontSize: MiViewFontSize.small,
  color: MiViewColors.tertiary,
  padding: '2px 8px',
  borderRadius: '10px',
  width: 'max-content',
  background: MiViewColors.vividOrange,
  marginBottom: '3px',
};

export const iconListStyle: SxProps<Theme> = {
  gap: '8px',
  overflowX: 'scroll',
  padding: '8px',
  alignSelf: 'center',
};

export const tacticIconBlockStyle: SxProps<Theme> = {
  width: '40px',
  minWidth: '40px',
  height: '40px',
  borderRadius: '40px',
  background: MiViewColors.softGray,
  position: 'relative',
  alignItems: 'center',
};

export const actionOrderBlockStyle: SxProps<Theme> = {
  position: 'absolute',
  left: '-8px',
  top: '-5px',
  width: '15px',
  height: '15px',
  fontSize: MiViewFontSize.xSmall,
  color: MiViewColors.tertiary,
  background: MiViewColors.primary,
  padding: '2px',
  borderRadius: '20px',
  textAlign: 'center',
};

export const iconStyle: SxProps<Theme> = {
  color: MiViewColors.tertiary,
};

export const menuButtonStyle: SxProps<Theme> = {
  minWidth: '38px',
  maxWidth: '38px',
  borderRadius: '40px',
  position: 'relative',
  left: '-10px',
};

export const menuIconStyle: SxProps<Theme> = {
  color: MiViewColors.royalBlack,
  fontSize: MiViewFontSize.large,
  marginRight: 0,
  width: '24px',
  height: '24px',
};
